import React from "react";
import PropTypes from "prop-types";
import { useMissionRole } from "hooks";
import { Col } from "components/Containers";
import { Spinner } from "components/Loader";
import ApplicationStepRequirements from "./ApplicationStepsRequirements";

/**
 * RoleApplicationSteps
 *
 * @param {Object}  role
 * @param {Boolean} loading
 */
const RoleApplicationSteps = ({ role, loading, ...props }) => {
  const { handleUpdateMissionRole, updatingRole } = useMissionRole({
    skip: true,
  });

  const handleUpdate = (name, required) => {
    const applicationSteps = role.applicationSteps?.map((step) => ({
      name: step.name,
      required: step.name === name ? required : step.required,
    }));

    handleUpdateMissionRole({
      id: role.id,
      params: { applicationSteps },
    });
  };

  if (loading || !role) return <Spinner size="1.5rem" />;

  return (
    <Col>
      <ApplicationStepRequirements
        steps={role.applicationSteps}
        onChange={handleUpdate}
        disabled={updatingRole}
        {...props}
      />
    </Col>
  );
};

RoleApplicationSteps.propTypes = {
  role: PropTypes.object,
  loading: PropTypes.bool,
};

export default RoleApplicationSteps;
